import React, { useEffect, useState } from 'react';
import { Space, Table, Tag } from 'antd';
import { useWebsiteStattistic } from '../website';
const columns = [
  {
    title: 'Tên',

    render: (_, record) => {
      return (
        <>
          {record.product?.name}
        </>
      )
    },
  },
  {
    title: 'Lượt xem',
    render: (_, record) => {
      return (
        <>
          {record.count}
        </>
      )
    },
  },



];

const Products = () => {
  const { data, filter, setFilter } = useWebsiteStattistic();
  const [topProduct, setTopProduct] = useState([])
  useEffect(() => {
    if (data.top_product) {
      setTopProduct(data.top_product);
    } else {
      setTopProduct([])
    }
  }, [data.top_product])



  return (
    <Table columns={columns} dataSource={topProduct} />
  )
};
export default Products;